<template>
  <div
    class="headline-with-cta__header md:flex md:gap-8 md:justify-between md:items-end"
    :class="{ 'bg-primary text-white': invertedColor }"
  >
    <div class="headline-with-cta__header-content flex flex-col gap-3">
      <component :is="titleTag" class="headline-with-cta__title" :class="{ '!text-white': invertedColor }">{{
        title
      }}</component>
      <component
        :is="textTag"
        class="headline-with-cta__description text-medium-normal"
        :class="{ '!text-white': invertedColor }"
        v-if="description"
      >
        <div v-html="description"></div>
      </component>
    </div>
    <div v-if="cta" class="headline-with-cta__cta">
      <SharedButton
        :label="cta.text || ''"
        :to="cta.target"
        :variant="ctaType"
        class="w-max mt-6 md:mt-0 md:h-max"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import type { Button } from '~/types/strapi';

  const props = withDefaults(
    defineProps<{
      title: string;
      description?: string;
      cta?: Button;
      titleTag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
      textTag?: 'div' | 'p';
      invertedColor?: boolean;
    }>(),
    {
      titleTag: 'h2',
      textTag: 'div',
      invertedColor: false,
    }
  );

  const ctaType = computed(() => {
    if (!props.invertedColor) return props.cta?.type;

    switch (props.cta?.type) {
      case 'primary':
        return 'secondary';
      case 'secondary':
        return 'secondary_inverted';
      default:
        return props.cta?.type;
    }
  });
</script>

<style></style>
